import React, { useCallback } from 'react';

declare global {
    interface Window {
        $zoho: any;
    }
}
import MainEventBus from '../../utils/evbus';
import styled from 'styled-components';

const ZohoChatElementDiv = styled.div({});

type StateProps = {
    bubbleId: string;
};

const ZohoChatAgent = () => {
    const [state] = React.useState<StateProps>({
        bubbleId: 'zoho-chat-' + Math.random().toString(36).substr(2, 9),
    });

    function isZohoLoaded() {
        return window.$zoho && window.$zoho.salesiq && typeof window.$zoho.salesiq.floatbutton !== 'undefined';
    }

    React.useEffect(() => {
        MainEventBus.on('SHOW_ZOHO_CHAT', openChat);

        return () => {
            MainEventBus.remove('SHOW_ZOHO_CHAT', openChat);
        };
    }, []);

    const openChat = () => {
        loadChat();

        if (isZohoLoaded()) {
            // hide the chat bubble
            window.$zoho.salesiq.floatbutton.visible("hide");
            // show the chat window
            window.$zoho.salesiq.floatwindow.visible("show");
            window.$zoho.salesiq.chatwindow.visible("show");
        }
    };

    const loadChat = async () => {
        const zohoKey = window.config.customerSupport?.providers.zoho.key;

        if (!zohoKey) return;
        
        // Insert Zoho snippet if not present
        if (!window.$zoho) {
            window.$zoho = window.$zoho || {};
            window.$zoho.salesiq = window.$zoho.salesiq || {
                widgetcode: zohoKey,
                values: {},
                ready: function() {
                    if (window.config.customerSupport?.providers?.zoho?.hasCustomField === '1') {
                        window.$zoho.salesiq.customfield.add(
                            {
                            "name": "Language",
                            "hint": "Choose one option",
                            "type": "selectbox",
                            "options": [
                                    {
                                        "text": "Chichewa",
                                        "value": "Chichewa"
                                    },
                                    {
                                        "text": "English",
                                        "value": "English"
                                    },
                                ],
                                "required": "true",
                                "visibility": "both",
                                "callback": function() {}
                            }
                        );
                    }

                    // hide the chat bubble
                    window.$zoho.salesiq.floatbutton.visible("hide");
                    // show the chat window
                    window.$zoho.salesiq.floatwindow.visible("show");
                    window.$zoho.salesiq.chatwindow.visible("show");

                    window.$zoho.salesiq.floatwindow.minimize(function()
                    {
                        window.$zoho.salesiq.floatbutton.visible("hide");
                        window.$zoho.salesiq.chatwindow.visible('hide');
                    });
                }
            };
        }

        const el = document.getElementById('zsiqscript');
        // Insert Zoho chat script if not present
        if (!el) {
            const src = 'https://salesiq.zoho.eu/widget';
            const lastScript = document.scripts[document.scripts.length - 1];
            const script = document.createElement('script');
            // script.type = "text/javascript";
            script.id = 'zsiqscript';
            script.async = true;
            // script.defer = true;
            script.src = src;
            // @ts-ignore
            script.onload = script.onreadystatechange = function () {
                // @ts-ignore
                if (this.readyState && this.readyState !== 'complete' && this.readyState !== 'loaded') {
                    return;
                }
            };
            lastScript?.parentElement?.insertBefore(script, lastScript.nextSibling);
        }
    };

    return <ZohoChatElementDiv id={state.bubbleId} className={'zoho-chat-element'}></ZohoChatElementDiv>;
};

export default ZohoChatAgent;

